import { useState, useRef } from "react"
import { useDeepCompareEffect } from "react-use"
import { Request, RequestHook, RequestState, Reload, AdditionalParams } from "./types"

export const createRequestHook =
  <I, O, SK = []>(request: Request<I, O>, useGetToken: () => () => Promise<string>): RequestHook<I, O, SK> =>
  (input: I): [RequestState<O>, Reload<I, SK>] => {
    const [state, setState] = useState<RequestState<O>>({ loading: true })
    const [trigger, setTrigger] = useState<number>(Date.now())
    const [reqInput, setReqInput] = useState<I | (I & AdditionalParams<SK>)>(input)
    const req = useRef<unknown>(null)
    const getToken = useGetToken()

    useDeepCompareEffect(() => {
      setReqInput(input)
    }, [input])

    useDeepCompareEffect(() => {
      setState({ ...state, loading: true })

      const promise = request(reqInput, getToken)
      req.current = promise

      promise.then((result) => {
        if (promise === req.current) {
          setState({ loading: false, result })
        }
      })
    }, [reqInput, trigger])

    return [
      state,
      (newInput?: I & AdditionalParams<SK>) => {
        if (newInput) {
          setReqInput(newInput)
          return
        }
        setTrigger(Date.now())
      },
    ]
  }
